import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=baf2d0bc&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=ts&"
export * from "./Dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=baf2d0bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf2d0bc",
  null
  
)

export default component.exports